import { CmsObjectWithDefault } from '@components/Cms/types';

// TODO: check the correct translation IDs
export type OtpLoginFormViewCmsKey =
    | 'phonenumberPlaceholder'
    | 'otpLoginSendOtpButton'
    | 'otpLoginTitle1'
    | 'otpLoginTitle2';

export const OtpLoginFormViewCmsWithDefault: CmsObjectWithDefault<OtpLoginFormViewCmsKey> = {
    phonenumberPlaceholder: {
        cmsId: 82026,
        defaultTranslation: 'Mobile number',
    },
    otpLoginSendOtpButton: {
        cmsId: 97925,
        defaultTranslation: 'Send OTP',
    },
    otpLoginTitle1: {
        cmsId: 82597,
        defaultTranslation: "Enter your mobile number and we'll send you a verification code to {0}",
    },
    otpLoginTitle2: {
        cmsId: 48461,
        defaultTranslation: 'sign in',
    },
};
